import Mime from 'mime/lite';
import Papa from 'papaparse';
import { ExportValue } from '../ExportDimension';
import { ExportFormat, ExportOutput } from '../ExportFormat';

export class CsvExportFormat implements ExportFormat {

    public readonly id = 'csv';
    public readonly label = 'CSV';
    public readonly desc = 'Best for importing into Excel and other data tools.';

    public apply(data: ExportValue[][]): ExportOutput[] {

        const table = data.map(row => row.map(cell => cell.value.replace(/\n/g, ' ')));
        const encoded = Papa.unparse(table, {
            delimiter: ',',
            quotes: true,
            skipEmptyLines: true,
        });

        return [
            ExportOutput(Mime.getType('csv'), encoded),
            ExportOutput(Mime.getType('text'), encoded)
        ];
    }

}
